import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Select from 'react-select';
import Modal from 'modules/common/components/Modal';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import useFormValidator from 'useFormValidator';
import { ModalContext } from 'App';
import { ucwords } from '../../../../../applications/helper';
import * as actions from '../../../action';
import * as c from '../../../constant';

function UpdateModal({
  updateNewBusinessActivities,
  formData,
  setFormData,
  getSingleNewBusinesses,
  id,
  getNewBusinessNatureIdList,
  newBusinessNatureIdList,
  getNewBusinessLineIdList,
  newBusinessLineIdList,
  isBusinessLineIdLoading,
  getNecessaryFieldsList,
  necessaryFieldsList,
  businessActivitiesId,
  businessActivitiesInfo,
}) {
  const setModal = useContext(ModalContext);

  const validateForm = useFormValidator(formData, {
    business_nature_id: 'required',
    business_line_id: 'required',
    capital_amount: 'required',
    gross_amount: 'required',
  });
  const permissions = getJson('permissions');
  useEffect(() => {
    getNewBusinessNatureIdList();
    getNewBusinessLineIdList();
    if (
      !_.isEmpty(_.get(businessActivitiesInfo, 'included.business_line.id'))
    ) {
      getNecessaryFieldsList({
        business_line_id: _.get(
          businessActivitiesInfo,
          'included.business_line.id'
        ),
      });
    }
  }, []);

  const handleOnSubmit = e => {
    e.preventDefault();

    const necessarydetails = _.omit(
      formData,
      'business_nature_id',
      'business_line_id',
      'capital_amount',
      'gross_amount',
      'override_amount'
    );

    const args = {
      business_nature_id: _.get(formData, 'business_nature_id'),
      business_line_id: _.get(formData, 'business_line_id'),
      capital_amount: _.get(formData, 'capital_amount'),
      gross_amount: _.get(formData, 'gross_amount'),
      override_amount: _.get(formData, 'override_amount'),
      details: { ...necessarydetails },
    };

    updateNewBusinessActivities(id, businessActivitiesId, args, () => {
      setModal({ isOpen: false });
      getSingleNewBusinesses(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    let keyValues = [];
    const details = _.get(businessActivitiesInfo, 'attributes.details')
      ? _.get(businessActivitiesInfo, 'attributes.details')
      : '';
    keyValues = Object.entries(details).map(([key, value]) => ({
      [key]: value.toString(),
    }));
    let finalObject = {};
    const badCallback = (a, i) => Object.assign(a, i);
    finalObject = keyValues.reduce(badCallback, {});
    setFormData({
      ...formData,
      ...finalObject,
      business_line_id:
        +_.get(businessActivitiesInfo, 'attributes.business_line_id') || '',
      business_nature_id:
        +_.get(businessActivitiesInfo, 'attributes.business_nature_id') || '',
      capital_amount:
        _.get(businessActivitiesInfo, 'attributes.capital_amount') || '',
      gross_amount:
        _.get(businessActivitiesInfo, 'attributes.gross_amount') || '',
      override_amount:
        _.get(businessActivitiesInfo, 'attributes.override_amount') || 0,
    });
  }, []);

  // select nature
  const handleNatureDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getNewBusinessLineIdList({ business_nature_id: e.value });
  };

  const selectBusinessNatureId = newBusinessNatureIdList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessNatureValue =
    selectBusinessNatureId.find(
      item => _.get(formData, 'business_nature_id')?.toString() === item.id?.toString()
    ) || '';

  // select line
  const handleLineDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });

    getNecessaryFieldsList({ business_line_id: e.value });
  };

  const onCheck = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.checked === true ? 1 : 0,
    });
  };

  const selectBusinessLineId = newBusinessLineIdList.map(x => ({
    label: _.get(x, 'attributes.name'),
    value: x.id,
    id: x.id,
  }));

  const findBusinessLineValue =
    selectBusinessLineId.find(item => _.get(formData, 'business_line_id')?.toString() === item.id?.toString()
    ) || (!_.isEmpty(findBusinessNatureValue) ? { 
      label: _.get(businessActivitiesInfo, "attributes.name"),
      value: _.get(businessActivitiesInfo, "attributes.business_line_id"),
      id: _.get(businessActivitiesInfo, "attributes.business_line_id"),
  } : "");

  // select necessary field
  const handleOfficeTypeDropDownChange = key => e => {
    setFormData({
      ...formData,
      [key]: e ? e.value : '',
    });
  };

  const selectOptions = list => {
    const newList = [];

    list.map(data => {
      return newList.push({
        label: ucwords(_.get(data, 'multiplier'))
          .replace(/_/g, ' ')
          .replace(/^(.)|\s+(.)/g, x => x.toUpperCase()),
        value: data.multiplier,
      });
    });
    return newList;
  };

  const handleOnChange = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.keys(formData).join(','), Object.values(formData).join(',')]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            <label className="form-label">
              Business Nature:{' '}
              {validateForm.renderMessage('business_nature_id')}
            </label>
            <Select
              options={selectBusinessNatureId}
              placeholder="Select Business Nature"
              value={findBusinessNatureValue}
              onChange={handleNatureDropDownChange('business_nature_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Business Line: {validateForm.renderMessage('business_line_id')}
            </label>
            <Select
              options={selectBusinessLineId}
              // placeholder="Select Business Line."
              isLoading={isBusinessLineIdLoading}
              value={findBusinessLineValue}
              onChange={handleLineDropDownChange('business_line_id')}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Capital Amount: {validateForm.renderMessage('capital_amount')}
            </label>
            <NumberFormat
              name="capital_amount"
              id="capital_amount"
              placeholder="0"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  capital_amount: floatValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'capital_amount', '')}` || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label className="form-label">
              Gross Amount: {validateForm.renderMessage('gross_amount')}
            </label>
            <NumberFormat
              name="gross_amount"
              id="gross_amount"
              placeholder="0"
              className="form-control"
              onValueChange={values => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  gross_amount: floatValue,
                });
              }}
              /* eslint-disable */
              isNumericString={true}
              thousandSeparator={true}
              allowNegative={true}
              allowLeadingZeros={true}
              displayType="input"
              prefix=""
              value={`${_.get(formData, 'gross_amount', '')}` || ''}
            />
          </div>
          {Acl(permissions, ['OVERRIDE BPLS AMOUNT']) && (
            <div className="col-12 form-group">
              <label htmlFor="last_name" className="form-label">
                Override Minimum Amount &nbsp;
              </label>
              <input
                name="override_amount"
                type="checkbox"
                checked={_.get(formData, 'override_amount') || 0}
                onChange={onCheck}
              />
            </div>
          )}
          <div className="col-12 form-group">
            {necessaryFieldsList.map(item => {
              return (
                <div>
                  <div>
                    {_.get(item, 'options') ? (
                      <div>
                        <label className="form-label">
                          {ucwords(
                            _.get(item, 'multiplier').replace(/_/g, ' ')
                          )}{' '}
                        </label>
                        <Select
                          onChange={handleOfficeTypeDropDownChange(
                            _.get(item, 'multiplier')
                          )}
                          options={selectOptions(_.get(item, 'options'))}
                          value={
                            selectOptions(_.get(item, 'options')).find(
                              x =>
                                _.get(formData, _.get(item, 'multiplier')) ===
                                _.get(x, 'value')
                            ) || ''
                          }
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className="form-group">
                    {!_.get(item, 'options') ? (
                      <div>
                        <label className="form-label">
                          {ucwords(
                            _.get(item, 'multiplier').replace(/_/g, ' ')
                          )}{' '}
                        </label>
                        <input
                          className="form-control"
                          name={_.get(item, 'label')}
                          id={_.get(item, 'label')}
                          onChange={handleOnChange(_.get(item, 'multiplier'))}
                          value={_.get(formData, _.get(item, 'multiplier'))}
                          required
                        />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3   ">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.defaultProps = {
  isBusinessLineIdLoading: false
}

UpdateModal.propTypes = {
  getSingleNewBusinesses: PropTypes.instanceOf(Function).isRequired,
  updateNewBusinessActivities: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  getNewBusinessNatureIdList: PropTypes.instanceOf(Function).isRequired,
  newBusinessNatureIdList: PropTypes.instanceOf(Array).isRequired,
  isBusinessLineIdLoading: PropTypes.bool,
  getNewBusinessLineIdList: PropTypes.instanceOf(Function).isRequired,
  newBusinessLineIdList: PropTypes.instanceOf(Array).isRequired,
  getNecessaryFieldsList: PropTypes.instanceOf(Function).isRequired,
  necessaryFieldsList: PropTypes.instanceOf(Array).isRequired,
  businessActivitiesId: PropTypes.string.isRequired,
  businessActivitiesInfo: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  newBusinessNatureIdList:
    _.get(api, `${c.GET_NEW_BUSINESS_NATURE_ID}.list`) || [],
  newBusinessLineIdList: _.get(api, `${c.GET_NEW_BUSINESS_LINE_ID}.list`) || [],
  newBusinessLineIdList: _.get(api, `${c.GET_NEW_BUSINESS_LINE_ID}.list`) || [],
  isBusinessLineIdLoading: _.get(api, 'loading', []).indexOf(c.GET_NEW_BUSINESS_LINE_ID) > -1,
  necessaryFieldsList: _.get(api, `${c.GET_NECESSARY_FIELD_LIST}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
